<div *ngIf="eventCancelled">
  <div class="container">
    <div class="row eventCancelled">
      <div class="col-12 py-1">
        <p class="text-danger">This event has been canceled.</p>
        <p class="mb-0">This event was canceled by the hiring organization. Please check your email for additional updates and communications.</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!eventCancelled">
  <form #scheduleForm="ngForm">
    <div class="row">
      <div class="col-12">
        <div class="formCotainer">
          <h2>{{model.applicantName}}</h2>
          <div class="formBody pt-2">
            <div class="row">
              <div class="col-12">
                <p *ngIf="availableTimeSlots.length">Please select a date and time that best fits your schedule and enter a comment in the field below. Interview slots may be offered to multiple job applicants on a first-come-first-serve basis.</p>
                <p *ngIf="!availableTimeSlots.length">Unfortunately, the interview date and times you were offered have been taken by other applicants, as they were made available on a first-come-first-serve basis. Please hold while the hiring official reviews the calendar in order to reschedule your interview.</p>
                <div class="" *ngFor="let timeSlot of availableTimeSlots; index as i;">
                  <div *ngIf="!timeSlot.isCancelled" class="form-check">
                    <input type="radio" class="form-check-input" id="time{{i}}" name="time" required ([ngModel])="timeSlot" [checked]="timeSlot.isConfirmed" (click)="confirmTimeSlot(timeSlot)" [disabled]="hasSubmitted">
                    <label class="form-check-label" for="time{{i}}">{{timeSlot.start | date:'MM/dd/yyyy h:mm a'}} <strong>{{getTimeZone(timeSlot.start)}}</strong></label>
                  </div>
                </div>
                <div class="form-check">
                  <div>
                    <input type="radio" class="form-check-input" id="rejected" name="time" required (change)="rejectedInterviewChanged()" [disabled]="hasSubmitted">
                    <label class="form-check-label" for="rejected">Click here if you are unable to attend one of the times offered or if no remaining time slots are available. Enter any additional comments in the space below.</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3 mb-2" *ngIf="availableTimeSlots.length">
              <div class="col-12">
                <div class="commentContainer">
                  <label for="comments">Please enter your comments here. <span class="text-danger">*</span></label>
                  <ckeditor id="comments" name="comments" required [config]="editorConfig" [editor]="Editor" [(ngModel)]="saveModel.message.content" [disabled]="hasSubmitted"></ckeditor>
                  <app-attachments [(attachments)]="saveModel.message.attachments"
                                  [supportedFileTypes]="supportedFileTypes"
                                  [maxFileSize]="maxFileSize"
                                  [maxCumulativeFileSize]="maxCumulativeFileSize"
                                  [saveRoute]="saveAttachmentRoute"
                                  [isRequired]="false"></app-attachments>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-2" *ngIf="availableTimeSlots.length">
      <div class="col-12 text-right">
        <button class="btn btn-primary" [disabled]="!scheduleForm.form.valid || !canSubmit() || processingServerSideRequest" (click)="save()" mdbWavesEffect>
          <i class="fa fa-spinner fa-spin" aria-hidden="true" *ngIf="processingServerSideRequest"></i> Send
        </button>
      </div>
    </div>
  </form>
</div>

<div mdbModal #thankYouModal="mdbModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myBasicModalLabel"
     aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close pull-right" aria-label="Close" (click)="thankYouModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h4 class="modal-title w-100" id="myModalLabel">Thank you</h4>
      </div>
      <div class="modal-body" *ngIf="submittedPrior">Your response to this request has already been received.</div>
      <div class="modal-body" *ngIf="!submittedPrior">Your submission has been received.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" aria-label="Close" (click)="thankYouModal.hide()" mdbWavesEffect>Ok</button>
      </div>
    </div>
  </div>
</div>
